var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center justify-content-center mb-3",staticStyle:{"padding-top":"10%"}},[_c('b-spinner',{key:_vm.variant,staticStyle:{"width":"6rem","height":"6rem"},attrs:{"label":"Παρακαλώ περιμένετε","variant":_vm.variant,"type":"border"}},[_c('span',[_vm._v("Παρακαλώ περιμένετε..")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }